import { type UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FormControl, FormField, FormItem, FormLabel } from '@/shared/ui/form'
import { Textarea } from '@/shared/ui/textarea'

interface PetObservationsFieldProps {
    form: UseFormReturn<any>
    petIndex: number
    isEditing: boolean
    currentValue?: string
}

export function PetObservationsField({ form, petIndex, isEditing, currentValue }: PetObservationsFieldProps) {
    const { t } = useTranslation()

    return (
        <FormField
            control={form.control}
            name={`pets.${petIndex}.observations`}
            render={({ field }) => (
                <FormItem className='col-span-2'>
                    <FormLabel>{t('pet.observations', 'Observaciones')}</FormLabel>
                    <FormControl>
                        {isEditing ? (
                            <Textarea
                                {...field}
                                placeholder={t(
                                    'pet.observationsPlaceholder',
                                    'Observaciones especiales sobre la mascota...',
                                )}
                            />
                        ) : (
                            <p>{currentValue || 'Sin observaciones'}</p>
                        )}
                    </FormControl>
                </FormItem>
            )}
        />
    )
}
